var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-basic',{attrs:{"section-data":_vm.sectionData}},[_c('template',{slot:"sectionContent"},[_c('card-icon-list',{attrs:{"data":_vm.list,"clip-angles":_vm.clipAngles,"has-subtitle":!!_vm.sectionData.sectionSideTitle}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }